import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import _ from 'lodash';

//components
import Button from '../../../components/Button';
import Title from '../../../components/Title';
import { useStore } from '../../../context/appContext';
import UserDataForm from '../../../components/Forms/UserDataForm';
import FormComponent from '../../../components/FormComponent';
import { modalTypes } from '../../../context/types';
import postConfirmData from '../../../apis/postConfirmData';
import postNotificate from '../../../apis/postNotificate';
import useGAEventsTracker from '../../../utils/useGAEventsTrackers';

const FormContainer = styled.div`
  grid-area: content;
  align-content: space-between;
`;

const Text = styled.p`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  font-size: 1rem;
  text-align: center;
`;

const BlueSpan = styled.span`
  font-weight: 600;
  color: ${(p) => p.theme.primary};
`;

const formDataInitialDefaults = {
  address: '',
  number: '',
  floor: '',
  departament: '',
  zipcode: '',
  phone: '',
  mail: '',
};

const cardOptions = [
  {
    id: 1,
    value: 1,
    label: 'Entrega en domicilio',
  },
  {
    id: 2,
    value: 2,
    label: 'Entrega en sucursal',
  },
];

function Form() {
  const {
    user: { id, street, streetNumber, floor, departament, zipCode, phone, mail, branchAddress, state, authorized },
    stepForward,
    setConfirmationData,
    setModal,
    setLoading,
    setError,
    notificate
  } = useStore();

  const GAEventsTracker = useGAEventsTracker("Form Data Page");
  useEffect(() => {
    GAEventsTracker("Visualiza pantalla datos domicilio");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formDataInitialState = _.merge({}, formDataInitialDefaults, {
    street: street,
    number: streetNumber,
    floor: floor,
    departament: departament,
    zipcode: zipCode,
    phone: phone,
    mail: mail,
    state: state,
    person_address_street: street,
    person_address_number: streetNumber,
    person_address_floor: floor,
    person_address_departament: departament,
    person_address_province: state,
    person_address_zipcode: zipCode,
    person_phone: phone,
    person_mail: mail,
    validate: false
  });

  const [formData, setFormData] = useState(formDataInitialState);
  const [showForm, setShowForm] = useState(2);

  const handleSelect = (value) => {
    if (value.id === 1) {
      setShowForm(1);
    } else if (value.id === 2) {
      setShowForm(2);
    }
  };

  const verifyData = (form) => {
    const postData = {}
    if (form.person_address_street !== street) {
      postData.person_address_street = form.person_address_street
    }
    if (form.person_address_number !== streetNumber) {
      postData.person_address_number = form.person_address_number
    }
    if (form.person_address_floor !== floor) {
      postData.person_address_floor = form.person_address_floor
    }
    if (form.person_address_departament !== departament) {
      postData.person_address_departament = form.person_address_departament
    }
    if (form.person_address_zipcode !== zipCode) {
      postData.person_address_zipcode = form.person_address_zipcode
    }
    if (form.person_phone !== phone) {
      postData.person_phone = form.person_phone
    }
    if (form.person_mail !== mail) {
      postData.person_mail = form.person_mail
    }
    return postData
  }
  const handleSaveData = () => {
    setLoading(true);

    setConfirmationData(formData);

    const data = verifyData(formData);
    GAEventsTracker("Guarda datos domicilio");
    postConfirmData(data, id, setError, authorized)
      .then(() => {
        GAEventsTracker("Guardar datos OK");
        setModal({ open: true, type: modalTypes.formSuccess })
        postNotificate(setError, notificate, authorized)
          .then(() => {
            setLoading(false);
            stepForward();
          })
      })
      .catch((error) => {
        GAEventsTracker("Guardar datos Error");
        setModal({ open: true, type: modalTypes.formRetry })
        setLoading(false);
      });
  };

  return (
    <>
      <Title grid="title">Confirmá tus datos para recibir tu Tarjeta de Crédito.</Title>
      <FormContainer>
        <FormComponent
          component="dropdown"
          options={cardOptions}
          selectAction={handleSelect}
          value={showForm}
        />
        {showForm === 2 && (
          <Text>
            Retirar la tarjeta por la sucursal ubicada en{' '}
            <BlueSpan>{branchAddress}</BlueSpan>
          </Text>
        )}
        <UserDataForm formData={formData} setFormData={setFormData} />
      </FormContainer>
      <Button filled grid="buttons" disabled={formData.validate} onClick={handleSaveData}>
        Guardar datos
      </Button>
    </>
  );
}

export default Form;
